export const update = {
  updateSuccessfully: '保存しました。',
}
